import { render } from "./sub.vue?vue&type=template&id=04b4ad6a&scoped=true"
import script from "./sub.vue?vue&type=script&lang=js"
export * from "./sub.vue?vue&type=script&lang=js"

import "./sub.vue?vue&type=style&index=0&id=04b4ad6a&lang=less&scoped=true"

import exportComponent from "/jenkins/workspace/zh-center-resource-webui_prev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b4ad6a"]])

export default __exports__